/**
 * Pravila za „nazad" strelicu u zaglavlju (HeaderBackButton).
 *
 * Na mobilnom prikazu strelica zauzima mesto hamburgera, ali samo kada je
 * korisnik „ušao" dublje u aplikaciju: na profil rezidenta, profil zaposlenog
 * ili u bilo koji otvoren side panel / modal. U tim slučajevima tap na
 * strelicu zatvara panel ili vraća na prethodnu stranicu, a hamburger (koji bi
 * inače tu stajao) ostaje dostupan na svim ostalim stranicama.
 */

// Segmenti ispod /residents koji NISU profil rezidenta (liste i podešavanja) -
// za njih strelica u zaglavlju nema smisla jer su to „root" stranice.
const RESIDENT_NON_PROFILE_SEGMENTS = new Set(['add', 'inactive', 'groups']);

// Isto za /employees (npr. „Neaktivni zaposleni" je lista, ne profil).
const EMPLOYEE_NON_PROFILE_SEGMENTS = new Set(['inactive']);

// Prvi segment putanje posle zadatog prefiksa, ili `null` ako ga nema.
const segmentAfter = (pathname, prefix) => {
  const match = new RegExp(`^${prefix}/([^/?#]+)`).exec(pathname || '');
  return match ? match[1] : null;
};

/**
 * Da li je putanja profil rezidenta (uključujući i pod-rute profila, npr.
 * `/residents/:id/health`). Liste kao `/residents`, `/residents/add`,
 * `/residents/inactive` i `/residents/groups` se ne računaju.
 */
export const isResidentProfilePath = (pathname) => {
  const segment = segmentAfter(pathname, '/residents');
  return segment !== null && !RESIDENT_NON_PROFILE_SEGMENTS.has(segment);
};

/**
 * Da li je putanja profil zaposlenog (`/employees/:id`). Lista
 * `/employees/inactive` se ne računa.
 */
export const isEmployeeProfilePath = (pathname) => {
  const segment = segmentAfter(pathname, '/employees');
  return segment !== null && !EMPLOYEE_NON_PROFILE_SEGMENTS.has(segment);
};

/**
 * Da li je trenutna ruta neki od „profila" (rezident ili zaposleni).
 */
export const isProfileRoute = (pathname) =>
  isResidentProfilePath(pathname) || isEmployeeProfilePath(pathname);

/**
 * Da li na mobilnom prikazu hamburger treba da zameni „nazad" strelica.
 *
 * Strelica se prikazuje kada je otvoren profil rezidenta/zaposlenog ili bilo
 * koji side panel (overlay) - tada je „nazad" smisleno (zatvara panel/vraća se
 * na listu). U svim ostalim slučajevima mesto hamburgera zauzima hamburger.
 */
export const shouldShowHeaderBack = (pathname, isOverlayOpen) =>
  isProfileRoute(pathname) || Boolean(isOverlayOpen);
